import React from 'react';
import {observer} from 'mobx-react';
import {InteractiveTable} from 'components';
import AddAssigneesModal from './AddAssigneesModal';
import CompanyDocument from 'stores/documents/CompanyDocument';
import {endpoints, types, auth} from 'shared/core';
import CompletedIcon from 'img/green-checkmark@2X.png';
import IncompleteIcon from 'img/circle--jumbo@2x.png';

const AssigneeStatusIcon = observer(({actioned}) => {
  return (
    actioned ? 
      <img className='mr1' src={CompletedIcon} width='10' alt='status'/> :
      <img className='mr1' src={IncompleteIcon} width='10' alt='status'/>
  );
});

const AssigneeStatuses = observer(({model}) => {
  return(
    <div>
      {model.sortedDocumentActions.map((action) => {
        return <div key={action.id} className='jumbo h5 flex align-items-middle'><AssigneeStatusIcon actioned={action.actionedAt}/>{action.employee.name}</div>
      })}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'company_settings.documents.Employee Name',
    attribute: 'primaryDocumentAction.employee.name',
    width: 3,
    sortBy: 'name'
  },
  {
    header: 'company_settings.documents.Assignee Statuses',
    width: 2,
    component: AssigneeStatuses
  },
  {
    header: 'company_settings.documents.Date Sent',
    attribute: 'createdAtView',
    width: 2,
    sortBy: 'sentDate'
  },
  {
    header: 'company_settings.documents.Date Completed',
    attribute: 'completedAtView',
    width: 2,
    sortable: false
  },
  {
    header: 'company_settings.documents.Due Date',
    attribute: 'primaryDocumentAction.formattedDueDate',
    width: 2,
    sortBy: 'dueDate'
  }
];

const LOCALIZATION = {
  interactive: {
    addModel: 'company_settings.documents.Add Assignees'
  },
  removeModal: {
    header: 'company_settings.documents.Revoke Company Document',
    subHeader: 'company_settings.documents.Are you sure you want to revoke this company document?',
    body: 'company_settings.documents.Revoked company documents will no longer be actionable. Document assignments will remain visible to admins.',
    saveCaption: 'company_settings.documents.Revoke'
  },
  emptyState: 'company_settings.documents.No employees have been assigned this document',
  removeModel: 'company_settings.documents.Revoke'
};

const DocumentActionsTable = observer(({uiState}) => {
  return (
    <div>
      <InteractiveTable
        title={uiState.companyDocument.name}
        uiState={uiState}
        columns={COLUMNS}
        localization={LOCALIZATION}
        searchable={true}
        saveStateToUrl={true}
        onMount={agent => uiState.setInteractiveAgent(agent)}
        onAdd={() => uiState.openAddAssigneeModal()}
        onRemove={model => uiState.destroyDocumentAction(model)}
        customLinks={model => uiState.customLinksFor(model)}
        showAddButton={uiState.companyDocument.hasLink('addAssignees')}
        proxy={{
          type: 'async',
          modelType: types.COMPANY_DOCUMENT,
          model: CompanyDocument,
          endpoint: endpoints.CHILD_DOCUMENTS.with(uiState.match.params.id)
        }}
      />
      <AddAssigneesModal
        companyDocument={uiState.companyDocument}
        isOpen={uiState.addAssigneeModalOpen}
        onHide={() => uiState.closeAddAssigneeModal()}
        onSuccess={() => uiState.onAssigneesAdded()}
      />
    </div>
  );
});

export default DocumentActionsTable;
